import { LedgerException } from '@injectivelabs/exceptions';
import AccountManager from './AccountManager.js';
import { loadEthType, loadTransportWebUSB, loadTransportWebHIDType, } from '../../lib.js';
export default class LedgerTransport {
    ledger = null;
    accountManager = null;
    static async getTransport() {
        const TransportWebUSB = await loadTransportWebUSB();
        const TransportWebHID = await loadTransportWebHIDType();
        try {
            if (await TransportWebHID.isSupported()) {
                const list = await TransportWebHID.list();
                if (list.length > 0 && list[0].opened) {
                    return new TransportWebHID(list[0]);
                }
                const existing = await TransportWebHID.openConnected().catch(() => null);
                if (existing) {
                    return existing;
                }
                return await TransportWebHID.request();
            }
            if (await TransportWebUSB.isSupported()) {
                const existing = await TransportWebUSB.openConnected().catch(() => null);
                if (existing) {
                    return existing;
                }
                return await TransportWebUSB.request();
            }
        }
        catch (e) {
            throw new LedgerException(new Error(e.message));
        }
        return TransportWebUSB.request();
    }
    async getInstance() {
        const EthereumApp = await loadEthType();
        if (!this.ledger) {
            const transport = await LedgerTransport.getTransport();
            this.ledger = new EthereumApp(transport);
            transport.on('disconnect', () => {
                this.ledger = null;
                this.accountManager = null;
            });
        }
        return this.ledger;
    }
    async getAccountManager() {
        if (!this.accountManager) {
            this.accountManager = new AccountManager(await this.getInstance());
        }
        return this.accountManager;
    }
    async refresh() {
        if (!this.ledger) {
            return new LedgerTransport();
        }
        this.ledger.transport.close();
        return new LedgerTransport();
    }
}
